import React, { ComponentProps } from "react";

function DownloadIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="download">
        <mask
          id="mask0_2901_1030907"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={20}
          height={21}
        >
          <rect
            id="Bounding box"
            y="0.533691"
            width={20}
            height={20}
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_2901_1030907)">
          <path
            id="download_2"
            d="M10.0001 13.4084C9.87572 13.4084 9.75661 13.3868 9.64279 13.3438C9.52896 13.3008 9.4254 13.2326 9.3321 13.1393L6.25738 10.0646C6.07078 9.87801 5.98012 9.657 5.9854 9.40157C5.99069 9.14612 6.08135 8.92511 6.25738 8.73852C6.44729 8.54861 6.67178 8.451 6.93083 8.44571C7.18989 8.44043 7.41438 8.53275 7.60429 8.72267L9.05221 10.1706V4.64569C9.05221 4.37968 9.14369 4.15518 9.32667 3.97221C9.50964 3.78924 9.73413 3.69775 10.0001 3.69775C10.2661 3.69775 10.4906 3.78924 10.6736 3.97221C10.8566 4.15518 10.948 4.37968 10.948 4.64569V10.1706L12.396 8.72267C12.5826 8.53275 12.8054 8.43961 13.0644 8.44323C13.3235 8.44686 13.548 8.54363 13.7379 8.73355C13.9172 8.92345 14.0096 9.14529 14.0149 9.39907C14.0201 9.65284 13.9278 9.87469 13.7379 10.0646L10.6681 13.1393C10.5749 13.2326 10.4713 13.3008 10.3575 13.3438C10.2436 13.3868 10.1245 13.4084 10.0001 13.4084ZM5.05992 17.3699C4.53515 17.3699 4.08799 17.1851 3.71842 16.8155C3.34885 16.446 3.16406 15.9988 3.16406 15.474V13.9219C3.16406 13.6559 3.25555 13.4315 3.43852 13.2485C3.62149 13.0655 3.84599 12.974 4.112 12.974C4.378 12.974 4.60249 13.0655 4.78546 13.2485C4.96843 13.4315 5.05992 13.6559 5.05992 13.9219V15.474H14.9403V13.9219C14.9403 13.6559 15.0318 13.4315 15.2148 13.2485C15.3978 13.0655 15.6223 12.974 15.8883 12.974C16.1543 12.974 16.3788 13.0655 16.5617 13.2485C16.7447 13.4315 16.8362 13.6559 16.8362 13.9219V15.474C16.8362 15.9988 16.6514 16.446 16.2818 16.8155C15.9123 17.1851 15.4651 17.3699 14.9403 17.3699H5.05992Z"
          />
        </g>
      </g>
    </svg>
  );
}

export default DownloadIcon;
